import { render, staticRenderFns } from "./AlertStatusTemplate.vue?vue&type=template&id=d4b94d6c"
import script from "./AlertStatusTemplate.vue?vue&type=script&lang=js"
export * from "./AlertStatusTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.35_cache-loader@4.1.0_webpack@4.47.0__css-load_84b6d598d32b1da7294c0119ce301628/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports